<template>
  <section>
    <b-tabs
      class="lr-tabs"
      v-model="activeTab"
    >
      <b-tab-item
        :label="$t(`Admin.tabLabel1`)"
        icon="account-plus"
      >
        <new-supplier />
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import NewSupplier from '@/components/miscellaneous/NewSupplier'

export default {
  name: 'Admin',
  data () {
    return {
      activeTab: 0
    }
  },
  components: {
    NewSupplier
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/Admin.vue